import { filterFromUrl } from '../lib/lib-util';
import { localCacheGet, session } from '@ekuaibao/session-info';
import { app } from '@ekuaibao/whispered';
import { Fetch } from '@ekuaibao/fetch';
import { pageViewCacheKey } from '@ekuaibao/lib/lib/help';
export function initRoute() {
    var noPathCache = filterFromUrl('noPathCache');
    var locationHash = location.hash.slice(1);
    var blackList = ['/login', '/auth-check', '/selectEnterprise5', '/mc-error', '/shared-error'];
    var shouldNotRedirect = !!~blackList.indexOf(locationHash);
    if (shouldNotRedirect || noPathCache) {
        return;
    }
    if (!Fetch.ekbCorpId && (window.__PLANTFORM__ === 'APP' || window.__PLANTFORM__ === 'THIRDPARTY')) {
        initFetchEkbCorpId();
    }
    var _a = pageViewCacheKey(Fetch.ekbCorpId), beforePagePathKey = _a.beforePagePathKey, beforePageKeyAppId = _a.beforePageKeyAppId;
    var beforePage = decodeURIComponent(localCacheGet(beforePagePathKey, true));
    var beforePageAppId = decodeURIComponent(localCacheGet(beforePageKeyAppId, true));
    if (beforePageAppId) {
        Fetch.appId = beforePageAppId;
    }
    var cannotInit = !beforePage || !beforePage.startsWith('/');
    if (cannotInit) {
        window.__PLANTFORM__ === 'MC' ? (beforePage = '/mc-tenant-list') : (beforePage = '/new-homepage');
    }
    app.useHistory({
        initialEntries: [beforePage],
        search: location.search.slice(1)
    });
}
function handleRefresh(path) {
    setTimeout(function () {
        location.replace(path);
    }, 4);
}
function initFetchEkbCorpId() {
    var ekbCorpId = filterFromUrl('ekbCorpId');
    if (!ekbCorpId) {
        var userInfo = session.get('user');
        if (userInfo) {
            ekbCorpId = userInfo.corpId;
        }
    }
    if (ekbCorpId) {
        Fetch.ekbCorpId = ekbCorpId;
    }
}
function initUrlCorpId() {
    var ekbCorpId = filterFromUrl('ekbCorpId');
    if (!ekbCorpId) {
        var userInfo = session.get('user');
        if (userInfo) {
            ekbCorpId = userInfo.corpId;
        }
    }
    if (ekbCorpId) {
        Fetch.ekbCorpId = ekbCorpId;
        var n = new Date().getTime();
        handleRefresh("?_=" + n + "&corpId=" + ekbCorpId + "#/");
        return void 0;
    }
}
